module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/dominos_cheese_love_social_media_spot.jpg";